import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  ReactiveFormsModule,
  FormsModule,
  FormBuilder,
  Validators
} from "@angular/forms";
import {
  UserService,
  OperationsService,
  AuthenticationService,
  StorageService
} from "../../_services/index";
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: "app-incomestatement",
  templateUrl: "./incomestatement.component.html",
  styleUrls: ["./incomestatement.component.css"]
})
export class IncomestatementComponent implements OnInit {
  public currentUser: any;
  public loading = false;
  public filter = {
    NEXT: "-1",
    DDATE: "",
    DDATE_: "",
    SHOW_ZERO_BALANCE: false,
    token: "",
    SHOW_ACTUAL:false
  };
  public data: any;
  start_date: any;
  end_date: any;
  constructor(
    public fb: FormBuilder,
    public operationsService: OperationsService,
    public storageService: StorageService,
    private toastr: ToastrService
  ) {
    this.currentUser = this.storageService.read<any>("currentUser");
    this.filter.token = this.currentUser.token;
  }

  ngOnInit() {
    this.getPlStatement();
  }
  showError(msg) {
    return this.toastr.error(msg, 'Error');
  }
  getProfitLoss() {
    this.operationsService
      .getProfitLoss(this.currentUser.token, this.filter)
      .subscribe(data => {
        this.data = data;
      });
  }
  getPlStatement() {
    this.loading = true;
    return this.operationsService
      .getPlStatement(this.currentUser.token, this.start_date, this.end_date,this.filter.SHOW_ACTUAL)
      .subscribe(
        res => {
          this.loading = false;
          this.data = res;
        },
        () => {
          this.loading = false;
          this.showError('An error occurred, try again');
        }
      );
  }
}
